import Link from "next/link";
import Image from "next/image";
import { storyblokEditable } from "@storyblok/react/rsc";

import type { AssetLinkStoryblok } from "@/component-types-sb";
import { getUrlFromLinkObject } from "@/lib/storyblok/utils";

type AssetLinkProps = {
  blok: AssetLinkStoryblok;
};

const AssetLink = ({ blok }: AssetLinkProps) => {
  const href = getUrlFromLinkObject(blok?.link) || undefined;

  const image = blok.asset && (
    <Image
      src={blok.asset.filename}
      alt={blok.asset.alt || ""}
      className="max-w-[170px] max-h-[100px] w-auto h-auto object-contain"
      width={250}
      height={150}
    />
  );

  if (href) {
    return (
      <Link
        href={href}
        target={blok.link?.target || "_self"}
        aria-label="Seite öffnen"
        className="cursor-pointer"
        {...storyblokEditable(blok)}
      >
        {image}
      </Link>
    );
  }

  return (
    <div {...storyblokEditable(blok)}>
      {image}
    </div>
  );
};

export default AssetLink;
